import { InvoicePaymentAuthorizedModel } from "@store/Types/InvoicePayment";
import * as React from "react";
import { useContext } from "react";

export interface HasInvoicePaymentAuthorizationContext {
    invoicePaymentAuthorization: InvoicePaymentAuthorizedModel;
}

export const InvoicePaymentAuthorizationContext = React.createContext<InvoicePaymentAuthorizedModel>({canPay: false, canPayByCC: false, canPayByChk: false});

export function withInvoicePaymentAuthorization<P extends HasInvoicePaymentAuthorizationContext>(Component: React.ComponentType<P>) {
    return function PaymentComponent(props: Omit<P, keyof HasInvoicePaymentAuthorizationContext>) {
        return (
            <InvoicePaymentAuthorizationContext.Consumer>
                {invoicePaymentAuthorization => <Component {...(props as P)} invoicePaymentAuthorization={invoicePaymentAuthorization} />}
            </InvoicePaymentAuthorizationContext.Consumer>
        );
    };
}

export const usePaymentAuthorizationContext = () => {
    return useContext(InvoicePaymentAuthorizationContext);
}